export default __webpack_public_path__ + "static/media/avatar_3_1.caffdf08.png";